module.exports = __webpack_public_path__ + "static/media/icon-param-triagem.abe2c514.png";